// extracted by mini-css-extract-plugin
export default {"answer":"O--z","bestAnswerHeading":"P--z","meta":"Q--z"};